import { Outlet } from "react-router-dom"
import { AppConfig } from "~/common/app-config"
import { useDocumentTitle } from "~/common/use-document-title"

export const LoginLayout = () => {
  useDocumentTitle("Login")
  return (
    <div className="flex min-h-screen flex-col bg-background sm:bg-muted/40">
      <div className="flex flex-grow items-center justify-center px-4 py-8 md:p-0">
        <div className="flex w-full max-w-[1100px] flex-col overflow-hidden rounded-[32px] shadow-2xl ring-1 ring-black/5 md:flex-row">
          <aside className="relative hidden h-[600px] w-[600px] items-center justify-center bg-primary text-primary-foreground md:flex">
            <div className="p-12">
              <p className="text-xs font-semibold uppercase tracking-widest opacity-70">
                Tanooki Labs
              </p>
              <h1 className="mt-5 text-5xl font-semibold tracking-tight">{AppConfig.app_name}</h1>
              <p className="mt-6 max-w-sm text-lg leading-8 opacity-85">
                Your ideas. Your experience. Your voice, out in the world.
              </p>
            </div>
          </aside>
          <main className="flex w-full flex-col items-center justify-center bg-background p-8 md:h-[600px] md:w-[500px]">
            <div className="w-full max-w-sm">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
      <footer className="mx-auto flex w-full max-w-[1440px] flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-muted-foreground sm:flex-row">
        <div>
          © {new Date().getFullYear()} {AppConfig.app_name} · All rights reserved
        </div>
      </footer>
    </div>
  )
}
